export default class Workplace {
  constructor() {
    this.name = null;
    this.phone = null;
    this.start = null;
    this.end = null;
  }
}
